@if (erzeugungsanlagen) {
    <div>
        <table
            mat-table [dataSource]="erzeugungsanlagen"
            class="erzeugungsanlagenTable"
            matSort
            (matSortChange)="_sortChange($event)"
            [matSortDirection]="sortDirection"
            [matSortActive]="sortActive"
        >
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr style="cursor: pointer" mat-row *matRowDef="let erzeugungsanlage; columns: columnsToDisplay"
                role="link"
                tabindex="0"
                (keydown.enter)="navigateToDetails(erzeugungsanlage)"
                (click)="navigateToDetails(erzeugungsanlage)"
            ></tr>
            <ng-container matColumnDef="westnetzId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Westnetz-ID</th>
                <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.westnetzId }}</td>
            </ng-container>
            <ng-container matColumnDef="installierteLeistungKW">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Installierte<br/>Leistung</th>
                <td mat-cell *matCellDef="let erzeugungsanlage;">
                    {{ erzeugungsanlage.installierteLeistungKW }} kW (&#8721;)
                </td>
            </ng-container>
            <ng-container matColumnDef="netzzuordnung.stationsname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzzuordnung<br/>Stationsname</th>
                <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.stationsname }}</td>
            </ng-container>
            <ng-container matColumnDef="netzzuordnung.ortsname">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzzuordnung<br/>Ortsname</th>
                <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.ortsname }}</td>
            </ng-container>
            <ng-container matColumnDef="netzzuordnung.trafoFeldName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzzuordnung<br/>Trafo/Feldnr</th>
                <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.trafoFeldName }}</td>
            </ng-container>
            <ng-container matColumnDef="netzzuordnung.deactivated">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzzuordnung<br/>Status</th>
                <td mat-cell *matCellDef="let erzeugungsanlage;">
                    @if (erzeugungsanlage.netzzuordnung.deactivated) {
                        <mat-icon matTooltip="Die Netzzuordnung ist deaktiviert worden. Bitte wählen Sie eine gültige aus."
                                  svgIcon="innogy_picto_speech-bubble_questionmark"
                                  class="warning-deactivated-netzzuordnung"
                                  aria-hidden="false"
                                  aria-label="Die Netzzuordnung ist deaktiviert worden. Bitte wählen Sie eine gültige aus."
                        >
                        </mat-icon>
                    }
                </td>
            </ng-container>
            <ng-container matColumnDef="abregelbareLeistungKW">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Abregelbare Leistung</th>
                <td mat-cell
                    *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.abregelbareLeistungKW }} @if (erzeugungsanlage.abregelbareLeistungKW !== undefined) {
                    <span>kW</span>
                }</td>
            </ng-container>
            <ng-container matColumnDef="anlagentyp.name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Primärenergieträger</th>
                <td mat-cell *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.anlagentyp.name }}</td>
            </ng-container>
            <ng-container matColumnDef="netzzuordnung.netzbetreiber.name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Netzbetreibername</th>
                <td mat-cell
                    *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.netzbetreiber.name }}
                </td>
            </ng-container>
            <ng-container matColumnDef="netzzuordnung.netzbetreiber.teilgebiet">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Teilgebiet</th>
                <td mat-cell
                    *matCellDef="let erzeugungsanlage;">{{ erzeugungsanlage.netzzuordnung.netzbetreiber.teilgebiet }}
                </td>
            </ng-container>
        </table>
    </div>
}
